import React, { Component } from "react";
import { CookiesStore } from "src/stores";
import { Button, Modal } from "src/views/shared/components";
import * as styles from "./CookiesModal.module.scss";
import { inject, observer } from "mobx-react";
import { withSiteSettings } from "src/libs/graphql/hoc/withSiteSettings";
import { ISettings } from "src/models";
import { seoSettings } from "src/libs/graphql/fragments";

export interface CookiesModalProps {
  settings: ISettings;
  cookiesStore?: CookiesStore;
}
@inject("cookiesStore")
@observer
class CookiesModalComponent extends Component<CookiesModalProps> {
  renderCookieModal() {
    const { onAcceptCookies } = this.props.cookiesStore;
    const { settings } = this.props;
    const { themeSettings } = settings;
    const { themeSettingsFields } = themeSettings;
    return (
      <>
        <div>
          <h6 className={styles.text}>
            By browsing the Resource Centre you are agreeing to our use of cookies. Read
            our{" "}
            <a
              href={
                settings?.themeSettings?.themeSettingsFields?.cookiePolicyUrl ||
                "https://resourcecentre.savethechildren.net/cookies"
              }
            >
              {" "}
              cookie policy.
            </a>
          </h6>
        </div>
        <div>
          <Button
            className={styles.button}
            color="red"
            size="small"
            onClick={() => onAcceptCookies()}
          >
            GOT IT!
          </Button>
        </div>
      </>
    );
  }

  render() {
    const { isOpen } = this.props.cookiesStore;

    return (
      <div className={styles.overlay}>
        {isOpen && <div className={styles.container}>{this.renderCookieModal()}</div>}
      </div>
    );
  }
}
export const CookiesModal = withSiteSettings(CookiesModalComponent);
